<template>
  <div class="content-item">
    <div
      class="contents"
      role="button"
      tabindex="0"
      :aria-label="video.title"
      @click.prevent="$emit('click-action', video)"
      @keyup.enter="$emit('click-action', video)"
    >
      <div class="content-info">
        <div class="content-thumbnail">
          <div class="content-thumbnail-holder">
            <card-src-set-image
              :img-prefix="imageUrlPrefix"
              :image="video.image"
              :title="video.title"
            />
          </div>
          <div class="content-details">
            <span class="eyebrow demi caps"
              >{{ bodyFocus.split(',')[0] }} -
              <span class="time-span">{{ video.minutes }} min</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'
import CardSrcSetImage from '@/components/images/card-src-set-image.vue'

export default defineComponent({
  name: 'VideoMiniCard',
  components: { CardSrcSetImage },
  props: {
    isMyFavoritesPage: {
      type: Boolean,
      default: false,
    },
    video: {
      type: Object as PropType<any>, // TODO: define/build model type
      required: true,
    },
  },
  emits: ['click-action'],
  data() {
    return {
      favoriteSubmitted: false,
      isCalendarModalOpen: false,

      // this is dumb, but have to do it because of the lazyload library is not
      // reactive
      reloadImage: false,
    }
  },
  computed: {
    ...mapState(useUserAuthStore, ['cdn']),

    imageUrlPrefix() {
      // get siteassets url from page load, allows CDN url to be added
      const siteAssetsPrefix = this.cdn.siteAssetsPrefix || '/siteassets'
      return siteAssetsPrefix + '/video'
    },

    isExclusive() {
      return !!this.video.is_exclusive
    },

    // could be multiple in db, but only show first match
    bodyFocus() {
      // elastic search has categories set, just return first in list
      if (this.video && Array.isArray(this.video.taxonomy)) {
        return this.video.taxonomy
          .filter((item: any) => item.category === 'bodyfocus')
          .map((item: any) => item.name)
          .join(', ')
      }

      return ''
    },
  },
  watch: {
    video() {
      this.forceReloadImage()
    },
  },
  methods: {
    // used to force reload the image by adding / removing lazyload class
    forceReloadImage() {
      this.reloadImage = true
      this.$nextTick(() => {
        this.reloadImage = false
      })
    },
  },
})
</script>
